import CreateTripRequestContainer from './create-trip-request-container';

export default CreateTripRequestContainer;
